var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatFormV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1972 13.1426V15.9381C18.1972 16.1198 18.1902 16.2945 18.1691 16.4622C18.008 18.3492 16.8939 19.2857 14.8408 19.2857H14.5606C14.3854 19.2857 14.2172 19.3696 14.1121 19.5093L13.2713 20.6275C12.8999 21.1237 12.2973 21.1237 11.9259 20.6275L11.0851 19.5093C10.994 19.3905 10.7908 19.2857 10.6366 19.2857H10.3564C8.12112 19.2857 7 18.7336 7 15.9381V13.1426C7 11.0948 7.94595 9.98363 9.83083 9.82288C9.999 9.80192 10.1742 9.79492 10.3564 9.79492H14.8408C17.0761 9.79492 18.1972 10.9131 18.1972 13.1426Z",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.3476V13.1431C21 15.1979 20.054 16.3021 18.1691 16.4628C18.1901 16.2951 18.1972 16.1204 18.1972 15.9387V13.1431C18.1972 10.9137 17.076 9.79551 14.8408 9.79551H10.3563C10.1742 9.79551 9.99898 9.80251 9.83081 9.82348C9.99197 7.94349 11.1061 7 13.1591 7H17.6436C19.8788 7 21 8.11821 21 10.3476Z",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0548 14.8621H15.0611",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6024 14.8621H12.6088",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1501 14.8621H10.1564",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFormV2);
export default __webpack_public_path__ + "static/media/chat-form-v2.b3b0aad8.svg";
export { ForwardRef as ReactComponent };